const vrboBathroomTypes = ["FULL_BATH", "SHOWER_INDOOR_OR_OUTDOOR"];

const vrboBedroomTypes = ["BEDROOM", "OTHER_SLEEPING_AREA"];

const vrboPropertyTypes = [
  "PROPERTY_TYPE_APARTMENT",
  "PROPERTY_TYPE_BARN",
  "PROPERTY_TYPE_BED_AND_BREAKFAST",
  "PROPERTY_TYPE_BOAT",
  "PROPERTY_TYPE_BUILDING",
  "PROPERTY_TYPE_BUNGALOW",
  "PROPERTY_TYPE_CABIN",
  "PROPERTY_TYPE_CAMPGROUND",
  "PROPERTY_TYPE_CARAVAN",
  "PROPERTY_TYPE_CASTLE",
  "PROPERTY_TYPE_CHACARA",
  "PROPERTY_TYPE_CHALET",
  "PROPERTY_TYPE_CHATEAU",
  "PROPERTY_TYPE_CONDO",
  "PROPERTY_TYPE_CORPORATE_APARTMENT",
  "PROPERTY_TYPE_COTTAGE",
  "PROPERTY_TYPE_ESTATE",
  "PROPERTY_TYPE_FARMHOUSE",
  "PROPERTY_TYPE_GUESTHOUSE",
  "PROPERTY_TYPE_HOSTEL",
  "PROPERTY_TYPE_HOTEL",
  "PROPERTY_TYPE_HOUSE",
  "PROPERTY_TYPE_HOUSE_BOAT",
  "PROPERTY_TYPE_LODGE",
  "PROPERTY_TYPE_MAS",
  "PROPERTY_TYPE_MILL",
  "PROPERTY_TYPE_MOBILE_HOME",
  "PROPERTY_TYPE_RECREATIONAL_VEHICLE",
  "PROPERTY_TYPE_RESORT",
  "PROPERTY_TYPE_RIAD",
  "PROPERTY_TYPE_STUDIO",
  "PROPERTY_TYPE_TOWER",
  "PROPERTY_TYPE_TOWNHOME",
  "PROPERTY_TYPE_VILLA",
  "PROPERTY_TYPE_YACHT",
];

const vrboCurrencies = [
  "ARS",
  "AUD",
  "BRL",
  "CAD",
  "CHF",
  "CNY",
  "COP",
  "CZK",
  "DKK",
  "EUR",
  "GBP",
  "HKD",
  "HRK",
  "HUF",
  "IDR",
  "ILS",
  "INR",
  "JPY",
  "KRW",
  "MXN",
  "MYR",
  "NOK",
  "NZD",
  "PLN",
  "RUB",
  "SEK",
  "SGD",
  "THB",
  "TRY",
  "USD",
  "ZAR",
];

const vrboEnumerations = {
  vrboBathroomTypes,
  vrboBedroomTypes,
  vrboPropertyTypes,
  vrboCurrencies,
};

export default vrboEnumerations;



// WEBPACK FOOTER //
// ./src/app/pages/rentals/detail/VrboConfigurationTab/VrboSchemaEnumerations.js